import { useFirebaseAuthContext } from "contexts/authorization/firebase-auth-contex"
import { IConfigurationContext } from "contexts/configuration/context"
import { useCallback, useEffect, useRef } from "react"

const useIdleTimer = (configuration: IConfigurationContext): void => {
  const authContext = useFirebaseAuthContext()
  const idleTimerRef = useRef<NodeJS.Timeout | null>(null)

  const sessionTimeout = configuration.user.sessionTimeoutMinutes
    ? configuration.user.sessionTimeoutMinutes * 60 * 1000
    : 3600000 // 1 hour

  const setupIdleTimer = useCallback(() => {
    if (idleTimerRef.current) {
      clearTimeout(idleTimerRef.current)
    }
    idleTimerRef.current = setTimeout(() => {
      authContext.logout()
    }, sessionTimeout)
  }, [authContext, sessionTimeout]) // Include authContext as dependency

  const handleResetIdleTimer = useCallback(() => {
    if (idleTimerRef.current) {
      clearTimeout(idleTimerRef.current)
    }
    setupIdleTimer()
  }, [setupIdleTimer])

  useEffect(() => {
    setupIdleTimer()
    document.addEventListener("mousemove", handleResetIdleTimer)
    document.addEventListener("keypress", handleResetIdleTimer)
    document.addEventListener("click", handleResetIdleTimer)
    document.addEventListener("touchmove", handleResetIdleTimer)

    return () => {
      if (idleTimerRef.current) {
        clearTimeout(idleTimerRef.current)
      }
      document.removeEventListener("mousemove", handleResetIdleTimer)
      document.removeEventListener("keypress", handleResetIdleTimer)
      document.removeEventListener("click", handleResetIdleTimer)
      document.removeEventListener("touchmove", handleResetIdleTimer)
    }
  }, [handleResetIdleTimer, setupIdleTimer]) // Include the function in dependencies
}

export default useIdleTimer
